import { keyBy } from "lodash";
import { updateLinks, toggleListing, sortListings } from "../../../api/report";

export const updateListingsOrder = (reportId, recordIds) => {
  sortListings(reportId, recordIds);
};

export const updateListingVisibility = (reportId, recordId) => {
  toggleListing(reportId, recordId);
};

export const updateModuleAndSubModuleLinks = (reportId, modules) => {
  const filteredModules = modules.map(({ key, isHidden }, index) => ({
    key,
    isHidden,
    sortOrder: index
  }));
  const filteredSubModules = modules.reduce(
    (subModules, module) => [
      ...subModules,
      ...module.subModules.map(({ key, isHidden }, index) => ({
        key,
        isHidden,
        sortOrder: index
      }))
    ],
    []
  );
  const newLinks = keyBy([...filteredModules, ...filteredSubModules], "key");
  updateLinks(reportId, newLinks);
};
